import track from './track';

const trackPageEvent = object => Object.assign({ event: 'PageView' }, object);

export default (object) => {
  track(trackPageEvent(object));
};
